import RentalCar from '@/views/RentalCar/index.vue'

const RentalCarRouter = {
  path: '/rental-car',
  name: 'RentalCar',
  component: RentalCar,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default RentalCarRouter
